
import { logOut } from "@/lib/api";
import EventBus from "@/lib/event-bus";
import { setLanguage } from "@/lib/i18n";
import { Component, MixedVue, mixins } from "@/vue";
import { gettersInstance, releaseHijack } from "@/lib/util";
import { RawLocation } from "vue-router";

@Component({
  name: "SidebarMenu",
})
export default class SidebarMenu extends mixins(MixedVue, gettersInstance(["user"])) {
  get availableLanguages(): AvailableLanguage[] {
    return Object.entries(this.$language.available).map(([code, label]) => {
      return { code, label };
    });
  }

  mounted() {
    document.querySelectorAll(".sidebar-menu-item").forEach((el) => {
      el.addEventListener("click", this.closeSidebar);
    });
  }

  beforeDestroy() {
    document.querySelectorAll(".sidebar-menu-item").forEach((el) => {
      el.removeEventListener("click", this.closeSidebar);
    });
  }

  closeSidebar() {
    this.$store.commit("setShowAppSidebar", false);
  }

  goTo(route: RawLocation, external = false) {
    if (!external) {
      this.$router.push(route).catch(() => {});
    } else {
      window.open(route as string, "_blank");
    }
  }

  async maybeReleaseUser() {
    if (this.user.is_hijacked) {
      releaseHijack();
    } else {
      this.$router
        .push({
          name: "staff-users",
        })
        .catch(() => {});
    }
  }

  changeLanguage(language: AvailableLanguage) {
    setLanguage(language.code.toLowerCase(), this);
  }

  async logOut() {
    try {
      await logOut();
      this.notify({
        type: "info",
        icon: "logout",
        text: this.$gettext("You have successfully logged out"),
      });
      this.$emit("hide");
      this.$store.commit("clearUser");
      await this.$store.dispatch("clearState");
    } catch {
      EventBus.$emit(EventBus.events.apiUnknownError);
    }
  }
}

interface AvailableLanguage {
  code: string;
  label: string;
}
